import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {AuditLog, AuditLogFilter, AuditLogSearchFilterModel, AuditLogType, SegmentAuditLog} from './audit-logs.service';
import {Observable} from 'rxjs';
import {loadAuditLogs, loadSegmentAuditLogs, selectAuditLogs, selectSegmentAuditLogs} from './audit-logs.state';
import {Page} from '../components/common-interfaces';

@Injectable({
  providedIn: 'root'
})
export class AuditLogsFacadeService {

  constructor(private store: Store) {
  }

  loadSegmentAuditLogs() {
    this.store.dispatch(loadSegmentAuditLogs());
  }

  selectSegmentAuditLogs(): Observable<SegmentAuditLog[]> {
    return this.store.select(selectSegmentAuditLogs);
  }

  loadAuditLogs(currentFilter: AuditLogSearchFilterModel, filterModel: Partial<AuditLogFilter>, auditLogType: AuditLogType) {
    this.store.dispatch(loadAuditLogs({auditLogType, filter: this.prepareFilter(currentFilter, filterModel)}));
  }

  selectAuditLogs(): Observable<Page<AuditLog>> {
    return this.store.select(selectAuditLogs);
  }

  private prepareFilter(currentFilter: AuditLogSearchFilterModel, filterModel: Partial<AuditLogFilter> = {}): AuditLogFilter {
    return <AuditLogFilter>{
      search: currentFilter.search,
      performedBy: currentFilter.performedBy,
      dateFrom: currentFilter.dateFrom,
      dateTo: currentFilter.dateTo,
      ...filterModel
    };
  }
}
